import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import queryString from 'query-string';
import { compose } from 'recompose';
import moment from 'moment';
import { List as ListImmutable, Record } from 'immutable';
import BudgetEmbedded from 'components/Budgets/BudgetEmbedded';
import { computeViewState, ViewStateEnum } from 'containers/OverviewPage/components/helpers';
import zeroStateIcon from 'assets/zero-state-images/budgets.svg';
import tracker from 'utils/tracker';
import UIState from 'components/UIState';
import LoadingView from 'components/LoadingView';
import ZeroStateView from 'components/ZeroStateView';
import QButton from 'components/QButton';
import WFBudgetSetup from 'components/Dialogs/WFBudgetSetup';

import { getBudgetsAction, createBudgetsAction, deleteBudgetsAction } from 'data/budgets/budgetsActions';
import { mkBudgetItem } from 'data/budgetItems/budgetItemsTypes';
import { getCategoryGroupListsAction } from 'data/categoryGroupLists/categoryGroupListsActions';
import { getCategoryGroupsAction } from 'data/categoryGroups/categoryGroupsActions';
import { getCategories as getCategoriesAction } from 'data/categories/actions';
import * as transactionActions from 'data/transactions/actions';
import { getPreferences as getPreferencesAction, setPreference as setPreferenceAction } from 'data/preferences/actions';
import * as budgetsSelectors from 'data/budgets/budgetsSelectors';
import * as budgetItemsSelectors from 'data/budgetItems/budgetItemsSelectors';
import * as budgetItemsActions from 'data/budgetItems/budgetItemsActions';
import * as categoryGroupListsSelectors from 'data/categoryGroupLists/categoryGroupListsSelectors';
import * as categoryGroupsSelectors from 'data/categoryGroups/categoryGroupsSelectors';
import * as categoriesSelectors from 'data/categories/selectors';
import * as preferencesSelectors from 'data/preferences/selectors';
import { getHasReportableAccounts, getAccountsById } from 'data/accounts/selectors';
import { getTransactionsByFilterFn } from 'data/transactions/selectors';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import { getFeatureFlags } from 'utils/featureFlags/selectors';
import underConstructionImage from 'assets/under-construction.png';
import { Helmet } from 'react-helmet';
import memoizeOne from 'memoize-one';
import { v4 as uuidv4 } from 'uuid';
import { DateTime } from 'luxon';
import { staticConfig } from 'containers/SetupPage/GettingStartedWebFirst/config';
import EditBudgetsDialog from 'components/Budgets/EditBudgetsDialog';
import QDialogs from 'components/QDialogs';
import { getIsWebfirstDataset } from 'data/datasets/selectors';
import GettingStartedModule from 'components/GettingStartedModule';

require('intersection-observer');

const staticConfigWF = staticConfig(true, false, true);
const budgetConfig = staticConfigWF.length && staticConfigWF.length >= 3 && staticConfigWF[2]; // Get third element Budgets

const styles = ({spacing}) => ({
  gettingStartedModuleRoot: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  buttonArea: {
    marginBottom: spacing(),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  setupButton: {
    borderRadius: 3,
    marginTop: spacing(5),
  },
});

class Budgets extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      showEditDialog: false,
      budgetsBarStuck: false,
      transactionsBarStuck: false,
      showNewBudgetSetup: false,
    };
    this.goToDate(new Date());
    if (!this.props.isLoading) {
      this.props.dispatchGetUserPreferencesAction();
      this.refreshData();
    }
  }

  componentWillReceiveProps(nextProps) {

    if (this.props.budgetsCreation &&
      (nextProps.uiState.startDate !== this.props.uiState.startDate) ||
      (nextProps.loadPending !== this.props.loadPending) ||
      (nextProps.isLoading !== this.props.isLoading)) {
      this.checkBudgetExistence(nextProps);
    }
  }

  componentDidUpdate(prevProps) {
    const navPath = this.fullNavPath(this.props);
    const prevNavPath = this.fullNavPath(prevProps);
    if (JSON.stringify(navPath) !== JSON.stringify(prevNavPath)) {
      const nodesType = this.props.budgetTreeNodes && this.props.budgetTreeNodes.reduce((results, node) => {
        const resultsMutable = results;
        resultsMutable.isExpense = resultsMutable.isExpense || node.negate < 0;
        resultsMutable.isIncome = resultsMutable.isIncome || node.negate > 0;
        return resultsMutable;
      }, {
        isIncome: false,
        isExpense: false,
      });
      let groupType;
      if (nodesType && nodesType.isIncome && !nodesType.isExpense) {
        groupType = 'income';
      } else if (nodesType && nodesType.isExpense && !nodesType.isIncome) {
        groupType = 'expense';
      } else {
        groupType = 'dynamic';
      }
      tracker.track(tracker.events.budgetView, { group_type: groupType, level: navPath && (navPath.length - 1) });
    }
  }

  fullNavPath(props) {
    let navPath;
    if (props.navigationPath && props.budget) {
      navPath = [props.budget.id, ...props.navigationPath.map((node) => node.id)];
    } else if (props.budget) {
      navPath = [props.budget.id];
    }
    return navPath;
  }

  goPrevMonth = () => {
    const newDate = new Date(this.props.uiState.startDate.getFullYear(), this.props.uiState.startDate.getMonth() - 1, 1);
    this.goToDate(newDate);
    tracker.track(tracker.events.budgetChange, { type: 'prev_date' });
  };

  goThisMonth = () => {
    this.goToDate(new Date());
    tracker.track(tracker.events.budgetChange, { type: 'cur_date' });
  };

  goNextMonth = () => {
    const newDate = new Date(this.props.uiState.startDate.getFullYear(), this.props.uiState.startDate.getMonth() + 1, 1);
    this.goToDate(newDate);
    tracker.track(tracker.events.budgetChange, { type: 'next_date' });
  };

  goToDate = (date) => {
    this.props.setUIState({
      startDate: new Date(date.getFullYear(), date.getMonth(), 1),
      endDate: new Date(date.getFullYear(), date.getMonth() + 1, 0),
    });
  };

  handleNavigationClick = (node) => {
    if (this.props.budget) {
      if (node) {
        this.props.history.replace(`/budgets?displayBudget=${this.props.budget.id}&displayNode=${node.key}`);
      } else {
        this.props.history.replace(`/budgets?displayBudget=${this.props.budget.id}`);
      }
    }
  };

  handleBudgetChange = (event) => {
    if (event.target && event.target.value) {
      this.props.dispatchSetSharedDatasetPreferenceAction({ budgetOptions: { lastViewedBudgetId: event.target.value } });
      this.props.history.replace(`/budgets?displayBudget=${event.target.value}`);
      tracker.track(tracker.events.budgetChange, { type: 'budget' });
    }
  };

  refreshData = () => {
    this.props.dispatchGetBudgetsAction();
    this.props.dispatchGetBudgetItemsAction();
    this.props.dispatchGetCategoryGroupListsAction();
    this.props.dispatchGetCategoryGroupsAction();
    this.props.dispatchGetCategoriesAction();
    this.props.dispatchGetPreferencesAction();
    this.props.dispatchGetTransactionsAction();
  };

  deleteBudget = () => {

    const { budget, dispatchDeleteBudgetAction } = this.props;
    if (!budget) return;

    this.props.dialogAlert(
      `Delete the budget "${budget.name}"`,
      `This will delete the budget "${budget.name}" and all its items.  This cannot be undone. Are you sure?`,
      (ret) => {
        if (ret.btnPressed === 'Yes') {
          dispatchDeleteBudgetAction(budget.set('isDeleted', true));
        }
      },
      ['Yes', 'Cancel'],
      'delete',
    );
  };

  checkBudgetExistence = (props) => {

    const { budgetItems, budgetTreeNodes, isLoading, loadPending, budget } = props;
    const { startDate } = props.uiState;

    if (!budget) return;

    const budgetItemsViewingYear = budgetItems.filter((x) => x.budgetId === budget.id && (moment(x.startDate).year() === moment(startDate).year()));
    const budgetItemsPriorYear = budgetItems.filter((x) => x.budgetId === budget.id && (moment(x.startDate).year() === (moment(startDate).year() - 1)));

    // if the year being viewed has no budgetItems, but the year PRIOR to it does, then
    // offer to create items for that year.
    if (isLoading || loadPending || budgetItemsViewingYear.size > 0 || budgetItemsPriorYear.size === 0) {
      return;
    }

    const year = moment(startDate).year();
    const priorYear = Number(year) - 1;

    if (budgetTreeNodes && budgetTreeNodes.size < 1) {
      this.props.dialogAlert(
        `Create budget for ${year}?`,
        `Quicken creates budgets one year at a time, and you currently do not have a budget defined for ${year}. `+
        `Would you like to create a ${year} budget based on your budget for ${priorYear}?`,
        (ret) => {
          if (ret.btnPressed.includes('Yes')) {
            // TODO create budget items for the next year
            const monthByMonth = !(ret.btnPressed.includes('December'));
            this.createNewBudget(props, startDate, budgetItemsPriorYear, monthByMonth);
          }
        },
        [`Yes, copy each month from ${priorYear}`, `Yes, copy from December, ${priorYear}`, 'No'],
        'info',
      )
    }
  };

  createNewBudget = (props, startDate, budgetItemsPriorYear, monthByMonth) => {

    const { budget, dispatchCreateBudgetItemsAction } = props;

    let allBudgetItemsToSave = new ListImmutable();
    // iterate over 12 months
    for (let month = 0; month < 12; month++) {
      const copyMonth = monthByMonth ? month : 11;
      const budgetItemsToCopy = budgetItemsPriorYear.filter((x) => moment(x.startDate).month() === copyMonth);

      const budgetItemsToSave = budgetItemsToCopy.map((item) =>
        mkBudgetItem({
          clientId: uuidv4().toUpperCase(),
          budgetId: budget.id,
          startDate: moment(startDate).month(month).format('YYYY-MM-DD'),
          amount: item.amount,
          groupId: item.groupId,
          type: item.type,
          coa: item.coa,
          calculatedActualsAmount: null,
          calclulatedRolloverAmount: null,
        }));
      allBudgetItemsToSave = allBudgetItemsToSave.concat(budgetItemsToSave.toList());
    }
    dispatchCreateBudgetItemsAction(allBudgetItemsToSave);
  };

  render() {
    const {
      classes,
      loadPending,
      isLoading,
      hasReportableAccounts,
      budgets,
      budget,
      navigationPath,
      budgetTreeNode,
      budgetTreeNodes,
      transactions,
      budgetsEnabled,
      theme,
      budgetAccountIds,
      budgetsCreation,
      isWebFirstDataset,
    } = this.props;

    const view = computeViewState(
      () => isLoading,
      () => !(budgets && budgets.size),
      hasReportableAccounts,
      loadPending,
      !budgetsEnabled,
    );

    const { showEditDialog, showNewBudgetSetup } = this.state;

    return (
      <div
        style={{ height: '100%' }}
      >
        <Helmet>
          <title>Budgets</title>
        </Helmet>

        {view === ViewStateEnum.DISABLED &&
        <img
          alt="page is under construction"
          src={underConstructionImage}
          style={{
            display: 'block',
            width: '50%',
            marginTop: 40,
            marginLeft: 'auto',
            marginRight: 'auto',
          }}
        />
        }

        {view === ViewStateEnum.LOADING &&
        <LoadingView
          style={{ height: theme.defaults.content.height }}
        />
        }

        {view === ViewStateEnum.LOAD_PENDING &&
        <ZeroStateView
          style={{ margin: 40 }}
          primary="No Data"
          icon={zeroStateIcon}
          secondary="We can't fetch your data from the server. Please try to refresh the page."
          useSmallerFont
        />
        }

        {(view === ViewStateEnum.ZERO || view === ViewStateEnum.EMPTY) && !isWebFirstDataset &&
        <ZeroStateView
          primary=""
          style={{ margin: 'auto', height: theme.defaults.content.height }}
          icon={zeroStateIcon}
          secondary={"It looks like you don't have a budget set up. If you have a budget set up on the desktop, be sure to sync it first." +
          `${budgetsCreation ? "Or you can create a budget from here by clicking 'Create' " : ''}`}
        >
          {budgetsCreation &&
          <div style={{ marginBottom: 25 }}>
            <QButton
              variant="contained"
              onClick={() => this.setState({ showNewBudgetSetup: true })}
            >
              Create a Budget
            </QButton>
          </div>
          }
        </ZeroStateView>
        }

        {(view === ViewStateEnum.ZERO || view === ViewStateEnum.EMPTY || (view === ViewStateEnum.MAIN && showNewBudgetSetup)) &&
          isWebFirstDataset && budgetConfig && (
          <div className={classes.gettingStartedModuleRoot}>
            <GettingStartedModule config={budgetConfig}/>
            <div className={classes.buttonArea}>
              {budgetConfig.buttons.map((btn) =>
                <div key={`SETUPBTN: ${btn.value}`}>
                  <QButton
                    variant="contained"
                    classes={{conButton: classes.setupButton}}
                    onClick={() => btn.value === 'createBudget' && this.setState({showNewBudgetSetup: true})}
                    id={btn.id}
                  >{btn.label}</QButton>
                </div>)
              }
            </div>
          </div>
        )}

        {view === ViewStateEnum.MAIN && !showNewBudgetSetup &&
          <div>
            <BudgetEmbedded
              isLoading={view === ViewStateEnum.LOADING}
              budgets={budgets}
              budgetsCreation={budgetsCreation}
              budget={budget}
              createNewBudget={this.createNewBudget}
              accountIds={budgetAccountIds}
              navigationPath={navigationPath}
              budgetTreeNodes={budgetTreeNode ? new ListImmutable([budgetTreeNode]) : budgetTreeNodes}
              transactions={transactions}
              startDate={this.props.uiState.startDate}
              goNextMonth={this.goNextMonth}
              goPrevMonth={this.goPrevMonth}
              goToDate={this.goToDate}
              goThisMonth={this.goThisMonth}
              handleNavigationClick={this.handleNavigationClick}
              handleBudgetChange={this.handleBudgetChange}
              budgetsBarStuck={this.state.budgetsBarStuck}
              transactionsBarStuck={this.state.transactionsBarStuck}
              onEdit={() => this.setState({ showEditDialog: true })}
              onDelete={this.deleteBudget}
            />
          </div>
        }
        {showNewBudgetSetup &&
          <WFBudgetSetup
            onClose={() => this.setState({ showNewBudgetSetup: false }) }
          />
        }
        {showEditDialog &&
          <EditBudgetsDialog
            onClose={() => this.setState({ showEditDialog: false })}
            budget={budget}
            startDate={this.props.uiState.startDate}
            month={moment(this.props.uiState.startDate).format('MM')}
            budgetTreeNodes={budgetTreeNodes}
          />
        }
      </div>
    );
  }
}

Budgets.propTypes = {
  classes: PropTypes.object,
  budgets: PropTypes.object,
  budgetsCreation: PropTypes.bool,
  budget: PropTypes.object,
  // budgetItems: PropTypes.object,
  budgetTreeNode: PropTypes.object,
  budgetTreeNodes: PropTypes.object,
  // categoryGroupLists: PropTypes.object,
  // categoryGroups: PropTypes.object,
  transactions: PropTypes.object,
  navigationPath: PropTypes.array,
  dispatchGetUserPreferencesAction: PropTypes.func,
  dispatchGetBudgetsAction: PropTypes.func,
  // dispatchCreateBudgetAction: PropTypes.func,
  dispatchDeleteBudgetAction: PropTypes.func,
  dispatchGetBudgetItemsAction: PropTypes.func,
  dispatchGetCategoryGroupListsAction: PropTypes.func,
  dispatchGetCategoryGroupsAction: PropTypes.func,
  dispatchGetCategoriesAction: PropTypes.func,
  dispatchGetPreferencesAction: PropTypes.func,
  dispatchGetTransactionsAction: PropTypes.func,
  dispatchSetSharedDatasetPreferenceAction: PropTypes.func,
  hasReportableAccounts: PropTypes.bool,
  isLoading: PropTypes.bool,
  loadPending: PropTypes.bool,
  uiState: PropTypes.any,
  setUIState: PropTypes.func,
  history: PropTypes.object,
  budgetsEnabled: PropTypes.bool,
  theme: PropTypes.object,
  // dialogForm: PropTypes.func,
  dialogAlert: PropTypes.func,
  budgetAccountIds: PropTypes.object,
  isWebFirstDataset: PropTypes.bool,
};

const transactionFilterFnGUID = uuidv4();
const transactionFilterFn = (transaction, props) => {
  let keepTransaction = !(transaction.source === 'SCHEDULED_TRANSACTION_PENDING');

  keepTransaction = (keepTransaction && props.accountIds && props.accountIds.size > 0) ? props.accountIds.has(transaction.accountId) : keepTransaction;
  const postedOnDate = DateTime.fromISO(transaction.postedOn).toJSDate();
  keepTransaction = (keepTransaction && props.startDate) ? postedOnDate >= props.startDate : keepTransaction;
  keepTransaction = (keepTransaction && props.endDate) ? postedOnDate <= props.endDate : keepTransaction;
  keepTransaction = (keepTransaction && props.coas && props.coas.size > 0) ? Boolean(
    (transaction.coa && props.coas.find((coa) => coa.type === transaction.coa.type && coa.id === transaction.coa.id
      && (transaction.coa.type !== 'ACCOUNT' || !props.negator || Math.sign(transaction.amount) === props.negator) )) // special casing for transfers - drop one side of a transfer
    ||
    (transaction.split && transaction.split.items &&
      transaction.split.items.find((splitItem) => props.coas.find((coa) => coa.type === splitItem.coa.type && coa.id === splitItem.coa.id
        && (splitItem.coa.type !== 'ACCOUNT' || !props.negator || Math.sign(splitItem.amount) === props.negator) )) // special casing for transfers - drop one side of a transfer
    )
  ) : false; // keepTransaction;

  return keepTransaction;
};
const transactionFilterPropsCached = memoizeOne((startDate, endDate, coas, accountIds, negator) => ({
  startDate,
  endDate,
  coas,
  accountIds,
  negator,
  filterFn: transactionFilterFn,
  filterFnGUID: transactionFilterFnGUID,
}));

function mapStateToProps(state, props) {
  const query = props.location && props.location.search && queryString.parse(props.location.search);
  const queryBudgetId = query && query.displayBudget ? query.displayBudget : null;
  const queryBudgetNodeKey = query && query.displayNode ? query.displayNode : null;
  const preferences = preferencesSelectors.getPreferences(state);
  const sharedDatasetPreferences = preferences && preferences.shared.dataset;
  const lastViewedBudgetId = sharedDatasetPreferences && sharedDatasetPreferences.budgetOptions && sharedDatasetPreferences.budgetOptions.lastViewedBudgetId;
  const budgets = budgetsSelectors.getBudgets(state);

  let budget = queryBudgetId && budgetsSelectors.getBudgetById(state, queryBudgetId);
  budget = budget || budgetsSelectors.getBudgetById(state, lastViewedBudgetId);
  budget = budget || (budgets && budgets.first());

  const budgetTreeNodes = budget && props.uiState && props.uiState.startDate && props.uiState.endDate &&
    budgetsSelectors.getBudgetTreeNodes(state, {
      budget,
      startDate: props.uiState.startDate,
      endDate: props.uiState.endDate,
    });
  const navigationPath = budgetTreeNodes && queryBudgetNodeKey && budgetsSelectors.pathToNodeWithKey(budgetTreeNodes, queryBudgetNodeKey);
  const budgetTreeNode = navigationPath && navigationPath.length > 0 && navigationPath[navigationPath.length - 1];

  const coas = budgetTreeNode ? budgetTreeNode.coas : budgetTreeNodes && budgetsSelectors.coasForNodes(budgetTreeNodes);
  const accountIds = budget && budget.filterAccountIds && budget.filterAccountIds.map((account) => account.id);
  const allAccounts = accountIds && getAccountsById(state);
  const budgetAccounts = accountIds && allAccounts && allAccounts.filter((account) => accountIds.includes(account.id) && account.currency === budget.currency);
  const budgetAccountIds = (budgetAccounts && budgetAccounts.map((account) => account.id)) || new ListImmutable([]);
  const negator = budgetTreeNode && budgetTreeNode.negate || undefined;

  const transactions = props.uiState && props.uiState.startDate && props.uiState.endDate && coas && budgetAccountIds &&
    getTransactionsByFilterFn(state, transactionFilterPropsCached(props.uiState.startDate, props.uiState.endDate, coas, budgetAccountIds, negator));

  return {
    budgetAccountIds,
    budgets,
    budget,
    budgetItems: budgetItemsSelectors.getBudgetItems(state),
    navigationPath,
    budgetTreeNode,
    budgetTreeNodes,
    transactions,
    preferences: preferencesSelectors.getPreferences(state),
    loadPending: Boolean(
      budgetsSelectors.getLoadPending(state)
      || budgetItemsSelectors.getLoadPending(state)
      || categoryGroupsSelectors.getLoadPending(state)
      || categoryGroupListsSelectors.getLoadPending(state)
      || categoriesSelectors.getLoadPending(state)
    ),
    isLoading: Boolean(
      budgetsSelectors.getIsLoading(state)
      || budgetItemsSelectors.getIsLoading(state)
      || categoryGroupsSelectors.getIsLoading(state)
      || categoryGroupListsSelectors.getIsLoading(state)
      || categoriesSelectors.getIsLoading(state)
    ),
    categoryGroupLists: categoryGroupListsSelectors.getCategoryGroupLists(state),
    categoryGroups: categoryGroupsSelectors.getCategoryGroupsById(state),
    hasReportableAccounts: getHasReportableAccounts(state, props),
    budgetsEnabled: getFeatureFlags(state).get('budgets'),
    budgetsCreation: getFeatureFlags(state).get('budgetsCreation'),
    isWebFirstDataset: getIsWebfirstDataset(state),
  };
}

const BudgetsUIState = Record({
  startDate: null,
  endDate: null,
});

const uiStateConfig = {
  name: 'Budgets',
  state: () => new BudgetsUIState(),
  persist: false,
};

function mapDispatchToProps(dispatch) {
  return {
    dispatchGetUserPreferencesAction: () => dispatch(getPreferencesAction({ section: 'shared', group: 'user' })),
    dispatchSetUserPreferenceAction: (preference) =>
      dispatch(setPreferenceAction({ section: 'shared', group: 'user', preference })),
    dispatchGetBudgetsAction: () => dispatch(getBudgetsAction()),
    dispatchCreateBudgetAction: (data) => dispatch(createBudgetsAction([data], { undo: { userMessage: 'New budget created.' } })),
    dispatchDeleteBudgetAction: (data) => dispatch(deleteBudgetsAction([data])),
    dispatchGetBudgetItemsAction: () => dispatch(budgetItemsActions.getBudgetItemsAction()),
    // dispatchRecalcBudgetsAction: (data) => dispatch(recalcBudgetsAction(data)),
    dispatchGetCategoryGroupListsAction: () => dispatch(getCategoryGroupListsAction()),
    dispatchGetCategoryGroupsAction: () => dispatch(getCategoryGroupsAction()),
    dispatchGetCategoriesAction: () => dispatch(getCategoriesAction()),
    dispatchGetPreferencesAction: () =>
      dispatch(getPreferencesAction({ section: 'shared', group: 'dataset' })),
    dispatchGetTransactionsAction: () =>
      dispatch(transactionActions.getTransactions(undefined, { context: 'budgets' })),
    dispatchSetSharedDatasetPreferenceAction: (preference) => dispatch(setPreferenceAction({ section: 'shared', group: 'dataset', preference })),
    dispatchCreateBudgetItemsAction: (data) => dispatch(budgetItemsActions.createBudgetItemsAction(data, { undo: { userMessage: 'Budget items created' } })),
  };
}

export default compose(
  UIState(uiStateConfig),
  QDialogs(),
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles, { withTheme: true })
)(withRouter(Budgets));
